import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function CtaBanner() {
  return (
    <section data-testid="cta-banner" className="pb-24 md:pb-32">
      <div className="container-x">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="relative overflow-hidden rounded-[2.5rem] bg-[#4A5D52] text-[#EFE8DD] p-10 md:p-20"
        >
          <div className="floral-blob w-[400px] h-[400px] bg-[#D88C76]/40 -bottom-40 -right-20" />
          <div className="relative grid grid-cols-1 md:grid-cols-12 gap-10 items-center">
            <div className="md:col-span-8">
              <h3 className="font-serif-display text-4xl md:text-5xl leading-[1.05] text-[#EFE8DD]">
                Ready to bring MHFA <br />
                <span className="italic text-[#D88C76]">into your workplace?</span>
              </h3>
              <p className="mt-6 text-[#EFE8DD]/80 max-w-xl leading-relaxed">
                Have a chat with us — no pressure, no sales pitch. Just a warm conversation
                about what your team needs.
              </p>
            </div>
            <div className="md:col-span-4 md:text-right">
              <Link to="/contact" data-testid="cta-banner-btn" className="inline-flex items-center gap-2 px-8 py-4 bg-[#EFE8DD] text-[#1E2A25] rounded-full font-medium hover:bg-[#D88C76] hover:text-[#FDFBF7] transition-all duration-500 hover:translate-y-[-2px]">
                Start the conversation <ArrowUpRight className="w-4 h-4" />
              </Link>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
